import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'cardNumberFormatPipe',

})

export class cardNumberFormatPipe implements PipeTransform {
    result: string;
    transform(value: string, cardNumber: string) {
        if (cardNumber) {
            cardNumber = cardNumber.replace(/\s/g, "");
            this.result = "";
            for (let i = 0; i < cardNumber.length; i++) {
            if (i % 4 === 0 && i !== 0) {
                this.result = this.result + " ";
                }
            this.result = this.result + cardNumber.charAt(i);
            }
            return this.result;
        } else {
            return null;
        }
    }
}